import { axiosInstance } from ".";

const getProvidersList = async (params) =>
  await axiosInstance.get("/service_providers", { params });

const addProvider = async (payload) =>
  await axiosInstance.post("/service_providers", payload);

const getProviderDetails = async (id) =>
  await axiosInstance.get(`/service_providers/${id}`);

const getGeneratedPassword = async ({ id, mangerId }) =>
  await axiosInstance.post(
    `/service_providers/${id}/service_provider_managers/${mangerId}/generate_tmp_password`
  );

const editProvider = async ({ id, data }) =>
  await axiosInstance.put(`/service_providers/${id}`, data);

const deleteProvider = async ({ id }) =>
  await axiosInstance.delete(`/service_providers/${id}`);

export {
  getProvidersList,
  addProvider,
  getProviderDetails,
  editProvider,
  deleteProvider,
  getGeneratedPassword,
};
